import React from 'react';
import { css } from '@corti/style';
import { useTheme } from '@corti/theme';
import { Base } from 'lib/cortiUI';
export function NotificationWrapper({ type, bgColor, textColor, children, isExpanded, }) {
    const theme = useTheme();
    return (React.createElement(Base, { "data-cy": "app-notification", "data-type": type, py: 2, px: 6, borderTopLeftRadius: 4, borderTopRightRadius: 4, borderBottomLeftRadius: isExpanded ? 0 : 4, borderBottomRightRadius: isExpanded ? 0 : 4, boxShadow: theme.shadows[2], background: bgColor, position: "relative", overflow: "hidden", minHeight: theme.space[9], width: "100%", display: "grid", gridAutoFlow: "row", gap: 4, className: css({ color: textColor }) }, children));
}
